/*!
 * Library.coffee - JavaScript Plugin
 *
 * Version  : 4.1 (2017/02/01)
 *
 * CopyRight (c) library.js Naotaka Kawakami.
 * Dual licensed under the MIT licenses.
 */
'use strict'

const Library = (function(){
	let Library = {}

	Library.Visitor = function(IMAGES, CALL){
		var floatFormat = function(number, n){
			return Math.round(parseFloat(number) * Math.pow(10, n)) / Math.pow(10, n);
		};
		
		var _ua = window.navigator.userAgent.toLowerCase();
		var _av = window.navigator.appVersion.toLowerCase();
		
		var data = {
			userAgent : _ua,
			type      : undefined,
			browser   : {app:undefined, version:undefined},
			device    : {os:undefined,  version:undefined}
		};
		
		var arr;
		if(_ua.indexOf("windows") !== -1 && _ua.indexOf("touch") !== -1 && _ua.indexOf("tablet pc") === -1){
			data.type      = 'tablet';
			data.device.os = 'windows tablet';
		}else if(_ua.indexOf('windows phone') !== -1){
			arr                 = /windows phone\ ([\d\.]+)/.exec(_ua);
			data.type           = 'mobile';
			data.device.os      = 'windows phone';
			data.device.version = floatFormat(arr[1], 1);
		}else if(_ua.indexOf("ipad") !== -1){
			arr                 = /os (\w+){1,3}/g.exec(_ua);
			data.type           = 'tablet';
			data.device.os      = 'ios';
			data.device.version = floatFormat(arr[1].replace(/_/g, '.'), 1);
		}else if(_ua.indexOf("iphone") !== -1 || _ua.indexOf("ipod") !== -1){
			if(_ua.indexOf("opera") !== -1){
				data.device.version = undefined;
			}else{
				arr                 = /iphone os (\w+){1,3}/g.exec(_ua);
				data.device.version = floatFormat(arr[1].replace(/_/g, '.'), 1);
			}
			data.type      = 'mobile';
			data.device.os = 'ios';
		}else if(_ua.indexOf("android") !== -1 && _ua.indexOf("mobile") !== -1){
			arr                 = /android\ ([\d\.]+)/.exec(_ua);
			data.type           = 'mobile';
			data.device.os      = 'android';
			data.device.version = floatFormat(arr[1], 1);
		}else if(_ua.indexOf("android") !== -1){
			arr                 = /android\ ([\d\.]+)/.exec(_ua);
			data.type           = 'tablet';
			data.device.os      = 'android';
			data.device.version = floatFormat(arr[1], 1);
		}else if(_ua.indexOf("bb10") !== -1 || _ua.indexOf("blackberry") !== -1){
			data.type      = 'mobile';
			data.device.os = 'blackberry';
			if(_ua.indexOf("bb10") !== -1){
				data.device.version = 'bb10';
			}else{
				arr                 = /blackberry\ ([\d\.]+)/.exec(_ua);
				data.device.version = arr[1];
			}
		}else if(_ua.indexOf("playbook") !== -1){
			data.type = 'tablet';
			data.device.os = 'blackberry';
			data.device.version = 'playbook';
		}else if(_ua.indexOf("windows") !== -1){
			arr = /windows nt\ ([\d\.]+)/.exec(_ua);
			data.type = 'pc';
			data.device.os = 'windows';
			if(arr[1] === '10.0'){
				data.device.version = 10;
			}else if (arr[1] === '6.3'){
				data.device.version = 8.1;
			}else if (arr[1] === '6.2'){
				data.device.version = 8;
			}else if (arr[1] === '6.1'){
				data.device.version = 7;
			}else if (arr[1] === '6.0'){
				data.device.version = 'vista';
			}else if (arr[1] === '5.2'){
				data.device.version = 'xp';
			}else if (arr[1] === '5.1'){
				data.device.version = 'xp';
			}
		}else if(_ua.indexOf("macintosh") !== -1){
			arr                 = /mac os x\ ([\d\.]+)/.exec(_ua);
			data.type           = 'pc';
			data.device.os      = 'mac';
			data.device.version = parseFloat(arr[1]);
		}
		
		if(_ua.indexOf('msie') >= 0 || _ua.indexOf('trident') >= 0){
			arr                  = /(msie|rv:?)\s?([\d\.]+)/.exec(_ua);
			data.browser.app     = 'ie';
			data.browser.version = arr ? parseFloat(arr[2]) : undefined;
		}else{
			if(_ua.indexOf('edge') !== -1){
				arr              = /edge\/([\d\.]+)/.exec(_ua);
				data.browser.app = 'edge';
			}else if(_ua.indexOf('firefox') !== -1 || _ua.indexOf('fxios') !== -1){
				arr              = _ua.indexOf('firefox') !== -1 ? /firefox\/([\d\.]+)/.exec(_ua) : /fxios\/([\d\.]+)/.exec(_ua);
				data.browser.app = 'firefox';
			}else if((_ua.indexOf('opera') !== -1 && _ua.indexOf("version") !== -1) || _ua.indexOf("opr") !== -1){
				arr              = _ua.indexOf("version") !== -1 ? /version\/([\d\.]+)/.exec(_ua) : /opr\/([\d\.]+)/.exec(_ua);
				data.browser.app = 'opera';
			}else if(_ua.indexOf('chrome') !== -1 || _ua.indexOf('crios') !== -1){
				arr              = _ua.indexOf('chrome') !== -1 ? /chrome\/([\d\.]+)/.exec(_ua) : /crios\/([\d\.]+)/.exec(_ua);
				data.browser.app = 'chrome';
			}else if(_ua.indexOf("bb10") !== -1 || _ua.indexOf("blackberry") !== -1 || _ua.indexOf("playbook") !== -1){
				arr              = (_ua.indexOf("blackberry") !== -1) ? /blackberry\ ([\d\.]+)/.exec(_ua) : undefined;
				data.browser.app = 'blackberry';
			}else if(_ua.indexOf('android') !== -1 && _ua.indexOf("mobile") !== -1){
				arr              = /android\ ([\d\.]+)/.exec(_ua);
				data.browser.app = 'android';
			}else if(_ua.indexOf('safari') !== -1 && _ua.indexOf("version") !== -1){
				arr              = /version\/([\d\.]+)/.exec(_ua);
				data.browser.app = 'safari';
			}
			data.browser.version = arr ? parseFloat(arr[1]) : undefined;
		}

		return data;
	}

  // よく使うのでプロパティにしとく
  Library.isPc = /^\/sp\//.test(location.pathname) ? false : true
  Library.isOldIos = Library.Visitor().device.os === 'ios' && Library.Visitor().device.version <= 8 ? true : false
  Library.isOldAndroid = Library.Visitor().device.os === 'android' && Library.Visitor().device.version <= 4.4 ? true : false

	return Library
})()

export default Library


// WEBPACK FOOTER //
// ./src/assets/js/utility/Library.js